import React, { useEffect } from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";

import { converDateIntoLocal } from "Constants";
function SessionRSVPUsersListItem(props) {
  let { value } = props;

  useEffect(() => {
    return () => {};
  }, []);

  return (
    <tr key={props.appUser.title}>
      <td>
        <div className="row">
          <div className="col-md-12 col-lg-12 d-flex">
            <div className="analytics-table-td">
              {props.appUser.title.length > 60
                ? props.appUser.title.substring(0, 60) + "..."
                : props.appUser.title}
            </div>
          </div>
        </div>
      </td>
      <td>
        <div className="row">
          <div className="col-md-12 col-lg-12 d-flex">
            <div
              className="analytics-table-td"
              style={{ textTransform: "capitalize" }}
            >
              {props.appUser.username} ({props.appUser.email})
            </div>
          </div>
        </div>
      </td>
      <td>
        <div className="row">
          <div className="col-md-12 col-lg-12 d-flex">
            <div className="analytics-table-td">
              {converDateIntoLocal(props.appUser.createdon)}
            </div>
          </div>
        </div>
      </td>
    </tr>
  );
}

function mapStateToProps(state) {
  return {
    session: state.session,
  };
}

const mapDispatchToProps = (dispatch) => bindActionCreators({}, dispatch);

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(SessionRSVPUsersListItem);
